import { Reducer } from "redux";
import { RegisterBeaconRequestLog } from "../../service/api-response/BeaconListSuccessResponse";
import * as beaconActions from "./beaconActions";

export interface BeaconState {
  beacons: {
    [organizationByKeyName: string]: RegisterBeaconRequestLog[] | undefined;
  };
  isBeaconsLoading: {
    [organizationByKeyName: string]: boolean;
  };
  hasMoreBeacons: {
    [organizationByKeyName: string]: undefined | boolean;
  };
}

const initialState: BeaconState = {
  beacons: {},
  isBeaconsLoading: {},
  hasMoreBeacons: {},
};

type SupportedActions =
  | beaconActions.GetBeaconsForOrganizationAction
  | beaconActions.GetBeaconsForOrganizationFailAction
  | beaconActions.GetBeaconsForOrganizationSuccessAction;

export const beaconReducer: Reducer<BeaconState, SupportedActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case beaconActions.GET_BEACONS_FOR_ORGANIZATION: {
      let newState = {
        ...state,
        isBeaconsLoading: {
          ...state.isBeaconsLoading,
          [action.organizationKeyName]: true,
        },
      };

      if (action.page === 1) {
        newState.hasMoreBeacons = {
          ...state.hasMoreBeacons,
          [action.organizationKeyName]: true,
        };

        newState.beacons = {
          ...state.beacons,
          [action.organizationKeyName]: undefined,
        };
      }

      return newState;
    }
    case beaconActions.GET_BEACONS_FOR_ORGANIZATION_FAIL: {
      return {
        ...state,
        isBeaconsLoading: {
          ...state.isBeaconsLoading,
          [action.organizationKeyName]: false,
        },
      };
    }
    case beaconActions.GET_BEACONS_FOR_ORGANIZATION_SUCCESS: {
      return {
        ...state,
        beacons: {
          [action.organizationKeyName]: [
            ...(state.beacons[action.organizationKeyName] || []),
            ...action.data,
          ],
        },
        isBeaconsLoading: {
          ...state.isBeaconsLoading,
          [action.organizationKeyName]: false,
        },
        hasMoreBeacons: {
          [action.organizationKeyName]: !!action.data.length,
        },
      };
    }
    default: {
      return state;
    }
  }
};
